import './../App.css';
import { connect } from 'react-redux';
import actions from './../store/actions';
import React from 'react';
import CustomCard from '../components/CustomCard';
import { Backdrop, CircularProgress, Box } from '@mui/material';
import { PAGE_URLS } from '../common/Constants';
import BackButton from '../components/atoms/BackButton';
import { v4 as uuidv4 } from 'uuid';

const allowedPlans = [
  'StarterMonthlyLimitedUsePerUser',
  'StarterAnnualLimitedUsePerUser',
  'ProfessionalMonthlyLimitedUsePerUser',
  'ProfessionalAnnualLimitedUsePerUser',
  'TeamsMonthly',
  'TeamsAnnual',
  'Pictory-API-Self-Service-USD-Monthly',
  'Pictory-API-Self-Service-USD-Yearly',
];

const allowedAddons = ['ADDITIONAL_VIDEO_HOURS', 'APIAdditionalCredits-USD-Monthly', 'TEAM_USERS', 'TEAM_USERS_YEARLY'];
class Plans extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showIframe: false,
      URL: null,
      loader: false,
      coupon: null,
    };
  }
  componentDidUpdate(prevProps) {
    if (this.props.getHostedPageResult && this.props.getHostedPageResult !== prevProps.getHostedPageResult) {
      if (this.props.getHostedPageResult.success) {
        this.setState({
          URL: this.props.getHostedPageResult.hostedPageUrl,
          showIframe: true,
          loader: false,
        });
      } else {
        if (this.props.getHostedPageResult.hasOwnProperty('error_code')) {
          const { param } = this.props.getHostedPageResult;
          if (param === 'coupon_ids[0]') {
            alert('The attached Coupon is invalid !');
            window.location.href = '/'; // Redirect to home page if coupon not found
            this.setState({ loader: false });
            return;
          }
        }
        this.setState({ loader: false });
        alert(this.props.getHostedPageResult.message || 'Cannot get hosted page !');
      }
    }
    if (this.props.credentials && this.props.credentials !== prevProps.credentials) {
      if (this.props.credentials.success) {
        const iframe = document.getElementById('myIframe'); // Get your iframe element
        const actionToSend = {
          type: 'CREDENTIALS_RECEIVED',
          payload: this.props.credentials.credential,
        };

        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage(actionToSend, process.env.REACT_APP_IFRAME_APP_URL);
        }
      } else {
        console.warn('Failed to fetch credentials from hosted page');
      }
    }
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const coupon = urlParams.get('code');
    if (coupon) {
      this.setState({ coupon });
    }
    const plan = urlParams.get('plan');
    const addonCode = urlParams.get('addon');
    const addonQuantity = urlParams.get('addonQuantity');
    const countryCode = urlParams.get('countryCode');
    let addons = [];
    if (allowedAddons.includes(addonCode) && addonQuantity > 0) {
      addons.push({
        addonCode,
        quantity: addonQuantity,
      });
    }
    if (allowedPlans.indexOf(plan) > -1) {
      this.getHostedPage(plan, coupon, addons, countryCode);
    }
  }

  getHostedPage = (planCode, couponCode = null, addons = [], countryCode = undefined) => {
    const checkoutId = uuidv4(); // Generate a unique socket ID for the user
    this.setState({ loader: true, planCode });
    let { coupon } = this.state;
    if (couponCode) coupon = couponCode;
    const payload = { planCode, coupon, tid: this.getFPTid(), countryCode };
    if (this.props?.location?.pathname === PAGE_URLS.API_PLAN_CHECKOUT) {
      payload.checkoutId = checkoutId;
      this.props.setupUserSocket(checkoutId);
    }
    if (addons?.length > 0) {
      payload.addons = addons;
    }
    payload.redirectUrl = process.env.REACT_APP_CHECKOUT_PAGE_URL;
    this.props.getHostedPage(payload);
  };

  getFPTid() {
    return window.FPROM && window.FPROM.data.tid;
  }

  updateShowIframeState = isAPI => {
    if (isAPI) {
      window.location.href = PAGE_URLS.API_PRICING;
    } else {
      window.location.href = PAGE_URLS.PRICING;
    }
  };

  render() {
    return (
      <>
        {this.state.showIframe ? (
          <>
            {window.location.pathname !== PAGE_URLS.API_PLAN_CHECKOUT ? (
              <div style={{ position: 'relative', textAlign: 'center' }}>
                <div style={{ position: 'absolute', left: 0, margin: '16px' }}>
                  <BackButton updateShowIframeState={() => this.updateShowIframeState(false)} />
                </div>
                <h3 style={{ display: 'inline-block', margin: '16px' }}>
                  Checkout below for new subscribers.&nbsp;
                  <span style={{ fontWeight: 'normal' }}>
                    (Already have a Pictory account?{' '}
                    <a
                      href={
                        this.state.planCode && !this.state.planCode.includes('Team')
                          ? `${process.env.REACT_APP_PICTORY_APP_URL}order-summary?plan=${this.state.planCode}`
                          : `${process.env.REACT_APP_PICTORY_APP_URL}`
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      Click here
                    </a>
                    .)
                  </span>
                </h3>
              </div>
            ) : (
              <div style={{ position: 'relative' }}>
                <div style={{ position: 'relative', left: 0, margin: '16px' }}>
                  <BackButton updateShowIframeState={() => this.updateShowIframeState(true)} />
                </div>
              </div>
            )}
            <iframe
              title={'hosted page'}
              style={{ height: '100vh', width: '100%', border: 'none' }}
              name="iframe1"
              src={this.state.URL}
              id="myIframe"
            ></iframe>
          </>
        ) : (
          <Box sx={{ zoom: 0.9 }}>
            <CustomCard getHostedPage={this.getHostedPage} location={this.props.location} />
            <Backdrop open={this.state.loader} sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}>
              <CircularProgress color="inherit" />
            </Backdrop>
          </Box>
        )}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    getHostedPageResult: state.hostedPage.getHostedPageResult,
    credentials: state.pushNotifications.credentials,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getHostedPage: payload => {
      dispatch(actions.getHostedPageRequest(payload));
    },
    setupUserSocket: checkoutId => {
      dispatch(actions.setupUserSocket(checkoutId));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Plans);
